export const CASE_STUDIES = [
    { key: "ActionBar", title: "Running AUS" },
    { key: "BreastCancerReport", title: "The Yerbba Report" },
    { key: "AIManualReviewTool", title: "AI Manual Review" },
    { key: "EHRSignup", title: "EHR Signup" },
]
